module.exports = __webpack_public_path__ + "static/img/PredictButton.2ed80d0a.svg";